var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _NotAvailFilters_instances, _NotAvailFilters_element, _NotAvailFilters_modal, _NotAvailFilters_adjustElement, _NotAvailFilters_resetElement, _NotAvailFilters_init;
import Emitter from '@resources/js/helpers/Emitter';
import Modal from '@resources/js/ui/Modal';
import { isDesktop } from '@resources/js/helpers/media';
const SELECTORS = {
    notice: '.js-not-avail-filters',
    content: '.js-not-avail-filters-content',
    close: '.js-not-avail-filters-close',
    adjust: '.js-not-avail-filters-adjust',
    reset: '.js-not-avail-filters-reset',
};
export const NOT_AVAIL_FILTERS_EVENTS = {
    ADJUST: 'not-avail-filters-adjust',
    RESET: 'not-avail-filters-reset',
};
class NotAvailFilters extends Emitter {
    constructor() {
        super();
        _NotAvailFilters_instances.add(this);
        _NotAvailFilters_element.set(this, void 0);
        _NotAvailFilters_modal.set(this, void 0);
        _NotAvailFilters_adjustElement.set(this, void 0);
        _NotAvailFilters_resetElement.set(this, void 0);
        __classPrivateFieldSet(this, _NotAvailFilters_element, document.querySelector(SELECTORS.notice), "f");
        if (!__classPrivateFieldGet(this, _NotAvailFilters_element, "f"))
            throw new Error('NotAvailFilters: element not found');
        __classPrivateFieldSet(this, _NotAvailFilters_adjustElement, __classPrivateFieldGet(this, _NotAvailFilters_element, "f").querySelector(SELECTORS.adjust), "f");
        __classPrivateFieldSet(this, _NotAvailFilters_resetElement, __classPrivateFieldGet(this, _NotAvailFilters_element, "f").querySelector(SELECTORS.reset), "f");
        // починаючи з таблета нотіс не закривається по бекдропу
        __classPrivateFieldSet(this, _NotAvailFilters_modal, new Modal(__classPrivateFieldGet(this, _NotAvailFilters_element, "f"), {
            hideOnBackdrop: isDesktop(),
            lockScroll: false,
            selectors: {
                close: SELECTORS.close,
                content: SELECTORS.content,
            },
        }), "f");
        __classPrivateFieldGet(this, _NotAvailFilters_instances, "m", _NotAvailFilters_init).call(this);
    }
    show() {
        __classPrivateFieldGet(this, _NotAvailFilters_modal, "f").show();
    }
    hide() {
        __classPrivateFieldGet(this, _NotAvailFilters_modal, "f").hide();
    }
}
_NotAvailFilters_element = new WeakMap(), _NotAvailFilters_modal = new WeakMap(), _NotAvailFilters_adjustElement = new WeakMap(), _NotAvailFilters_resetElement = new WeakMap(), _NotAvailFilters_instances = new WeakSet(), _NotAvailFilters_init = function _NotAvailFilters_init() {
    __classPrivateFieldGet(this, _NotAvailFilters_adjustElement, "f").addEventListener('click', () => {
        __classPrivateFieldGet(this, _NotAvailFilters_modal, "f").hide();
        this.emit(NOT_AVAIL_FILTERS_EVENTS.ADJUST);
    });
    __classPrivateFieldGet(this, _NotAvailFilters_resetElement, "f").addEventListener('click', () => {
        __classPrivateFieldGet(this, _NotAvailFilters_modal, "f").hide();
        this.emit(NOT_AVAIL_FILTERS_EVENTS.RESET);
    });
};
export default NotAvailFilters;
